import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// @ts-ignore
import Point from "../../geo/point";
import { indexTouches } from "../handler_util";
export default class TouchPanHandler {
  constructor(options) {
    _defineProperty(this, "enabled", void 0);
    _defineProperty(this, "active", void 0);
    _defineProperty(this, "touches", void 0);
    _defineProperty(this, "minTouches", void 0);
    _defineProperty(this, "clickTolerance", void 0);
    _defineProperty(this, "sum", void 0);
    this.minTouches = 1;
    this.clickTolerance = options.clickTolerance || 1;
    this.reset();
  }
  reset() {
    this.active = false;
    this.touches = {};
    this.sum = new Point(0, 0);
  }
  touchstart(e, points, mapTouches) {
    return this.calculateTransform(e, points, mapTouches);
  }
  touchmove(e, points, mapTouches) {
    if (!this.active) {
      return;
    }
    e.preventDefault();
    return this.calculateTransform(e, points, mapTouches);
  }
  touchend(e, points, mapTouches) {
    this.calculateTransform(e, points, mapTouches);
    if (this.active && mapTouches.length < this.minTouches) {
      this.reset();
    }
  }
  touchcancel() {
    this.reset();
  }
  enable() {
    this.enabled = true;
  }
  disable() {
    this.enabled = false;
    this.reset();
  }
  isEnabled() {
    return this.enabled;
  }
  isActive() {
    return this.active;
  }
  calculateTransform(e, points, mapTouches) {
    if (mapTouches.length > 0) {
      this.active = true;
    }
    const touches = indexTouches(mapTouches, points);
    const touchPointSum = new Point(0, 0);
    const touchDeltaSum = new Point(0, 0);
    let touchDeltaCount = 0;
    for (const identifier in touches) {
      if (touches[identifier]) {
        const point = touches[identifier];
        const prevPoint = this.touches[identifier];
        if (prevPoint) {
          touchPointSum._add(point);
          touchDeltaSum._add(point.sub(prevPoint));
          touchDeltaCount++;
          touches[identifier] = point;
        }
      }
    }
    this.touches = touches;
    if (touchDeltaCount < this.minTouches || !touchDeltaSum.mag()) {
      return;
    }
    // @ts-ignore
    const panDelta = touchDeltaSum.div(touchDeltaCount);
    this.sum._add(panDelta);
    if (this.sum.mag() < this.clickTolerance) {
      return;
    }
    // @ts-ignore
    const around = touchPointSum.div(touchDeltaCount);
    return {
      around,
      panDelta
    };
  }
}